module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-message"
  }, [_c('div', {
    staticClass: "view-message__wrapper"
  }, [_c('div', {
    staticClass: "view-message__header"
  }, [_c('h1', {
    staticClass: "h1 m0",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v(_vm._s(_vm.getSelectedMessage.subject))]), _vm._v(" "), _c('p', {
    staticClass: "p small c-accent"
  }, [_vm._v("From " + _vm._s(_vm.getSelectedMessage.from))]), _vm._v(" "), _c('p', {
    staticClass: "p small c-accent tar"
  }, [_vm._v(_vm._s(_vm.date))])]), _vm._v(" "), _c('div', {
    staticClass: "view-message__message"
  }, _vm._l((_vm.formattedMessage), function(line, key) {
    return _c('p', {
      key: key,
      staticClass: "p"
    }, [_vm._v("\n        " + _vm._s(line) + "\n      ")])
  }), 0), _vm._v(" "), (_vm.receivedMessage && _vm.canReply) ? _c('module-button', {
    attrs: {
      "label": "Reply",
      "button": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.replyToMessage.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf092bca"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ViewMessage.vue
// module id = 518
// module chunks = 0